import React from 'react';
import {
    Icon,
    IconContainer,
    TooltipContainer,
    TooltipContent,
    TooltipTriangle,
} from 'src/domains/players/webview/components/Account/summaryTab/accountSummary/Tooltip/Tooltip.style';

export type TooltipType = 'default' | 'info' | 'error';

type TooltipPropsType = {
    content: React.ReactNode;
    type: TooltipType;
};

export const Tooltip = ({ content, type }: TooltipPropsType): JSX.Element => {
    return (
        <TooltipContainer data-test={`${type}-tooltip`}>
            <IconContainer>
                <Icon type={type} />
            </IconContainer>
            <TooltipContent
                className='tooltip-content'
                type={type}
            >
                {content}
            </TooltipContent>
            <TooltipTriangle
                className='tooltip-triangle'
                type={type}
            />
        </TooltipContainer>
    );
};
